import ButtonIcon from '@stripcash/ui-kit/components/ButtonIcon';
import Text, { TextPresets } from '@stripcash/ui-kit/components/Text';
import CloseIcon from '@stripcash/ui-kit/icons/close.svg';
import { FC, RefObject } from 'react';
import CheckMarkIcon from '@stripcash/ui-kit/icons/checkMark.svg';
import Button, { ButtonColor } from '@stripcash/ui-kit/components/Button';

import { Translate } from 'common/i18n/types';

import s from './styles.module.css';

type CloseModalStepProps = {
  t: Translate;
  ref: RefObject<HTMLDivElement | null>;
  onClose: () => void;
};

const CloseModalStep: FC<CloseModalStepProps> = ({ t, ref, onClose }) => (
  <div ref={ref} className={s.closeModalStep}>
    <div className={s.closeModalStepCrossBtn}>
      <ButtonIcon onClick={onClose}>
        <CloseIcon size={12} />
      </ButtonIcon>
    </div>

    <div className={s.closeModalStepCheckIcon}>
      <CheckMarkIcon color="#36b736" size={50} />
    </div>

    <div className={s.closeModalStepTitle}>
      <Text preset={TextPresets.H3}>{t('closeStep.title')}</Text>
    </div>

    <Text preset={TextPresets.Body12}>{t('closeStep.subtitle')}</Text>

    <div className={s.closeModalStepCloseBtn}>
      <Button fullWidth onClick={onClose} color={ButtonColor.Default}>
        {t('close')}
      </Button>
    </div>
  </div>
);

export default CloseModalStep;
